import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import type { FollowingStore } from "@/types/layout";
import LiveIcon from "./LiveIcon";

interface StoreListItemProps {
  store: FollowingStore;
  onClick?: () => void;
}

export function StoreListItem({ store, onClick }: StoreListItemProps) {

  
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className="w-full justify-between h-[43px] px-[10px] py-2 rounded-[5px] hover:bg-sidebar-active-bg/5"
    >
      <div className="flex items-center gap-[8px]">
        <Avatar className="w-[21px] h-[21px]">
          <AvatarImage src={store.avatar} alt={store.name} />
          <AvatarFallback className="text-[10px]">
            {store.name.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <span className="text-[15px] font-lexend font-normal tracking-[-0.22px] capitalize text-sidebar-text">
          {store.name}
        </span>
      </div>

      {store.isLive ? (
        <LiveIcon width={15} height={11} color="#ff0000" />
      ) : (
        <div className="status-dot-live" />
      )}
    </Button>
  );
}
